function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.46 283.46"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M283.465 276.378H.001V0H85.04v140.059l99.21-49.606v49.607l99.215-49.606v185.924zM28.347 248.032h226.772V136.318l-99.215 49.606v-49.606l-99.21 49.606V28.347H28.347v219.685z",
  id: "Industry"
})));